document.addEventListener('DOMContentLoaded', () => {
  if (typeof Swiper === 'undefined') return;

  const mq = window.matchMedia('(max-width: 767px)');

  const initOne = (section) => {
    if (section.__recInitBound) return;
    section.__recInitBound = true;

    let swiper = null;

    const update = () => {
      const container = section.querySelector('.productRecommendationsCustom_swiper');
      const wrapper = container && container.querySelector('.swiper-wrapper');
      if (!container || !wrapper || !wrapper.children.length) return;

      if (mq.matches) {
        if (!swiper) {
          swiper = new Swiper(container, {
            slidesPerView: "auto",
            spaceBetween: 24,
          });
        }
      } else {
        if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
      }
    };

    let tries = 0;
    const maxTries = 40;

    const tick = () => {
      tries += 1;
      update();
      const container = section.querySelector('.productRecommendationsCustom_swiper');
      const inited = container && container.classList.contains('swiper-initialized');
      if (inited || tries >= maxTries) return;
      setTimeout(tick, 150);
    };

    tick();
    mq.addEventListener('change', update);
  };

  document.querySelectorAll('.productRecommendationsCustom').forEach(initOne);

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.productRecommendationsCustom').forEach(initOne);
  });
});
